import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface AdminUserState {
    currentUser: any[];
}

const initialState: AdminUserState = {
    currentUser: [null, {
        blocked: false,
        email: null,
        auth: "user",
        secondaryAuth: "any"
    }, false]
};

const adminUser = createSlice({
    name: "AdminUser",
    initialState,
    reducers: {
        setAdminUser: (state, action: PayloadAction<any[]>) => {
            state.currentUser = action.payload;
            state.currentUser[2] = true;
        }
    }
})

export const { setAdminUser } = adminUser.actions

export default adminUser.reducer
